module.exports = __webpack_public_path__ + "r-v3/img/ml_49_01.b6edafc7.jpg";